module.exports = __webpack_public_path__ + "img/item-7(1920).a09f3e85.jpg";